export const ToggleSwitch = ({ checked, onChange, disable = true }) => {
    return (
      <label className="relative inline-block w-14 h-8">
        <input
          type="checkbox"
          className="opacity-0 w-0 h-0"
          checked={checked}
          onChange={onChange}
          disabled= {!disable}
        />
        <span
          className={`absolute cursor-pointer top-0 left-0 right-0 bottom-0 bg-gray-300 transition-colors duration-300 ease-in-out rounded-full 
             ${checked  ? 'bg-blue-500' : ''}`}
        >
          <span
            className={`absolute left-1 bottom-1 bg-white w-6 h-6 transition-transform duration-300 ease-in-out rounded-full
               ${checked ? 'transform translate-x-6' : ''}`}
          />
        </span>
      </label>
    );
  };